exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".radioClass-cd0b6458{margin-bottom:0px}\n", ""]);

// Exports
exports.locals = {
	"radioClass": "radioClass-cd0b6458"
};